import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import moment from "moment/moment";

const Homepage = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const role = JSON.parse(localStorage.getItem("roles"));
  const leaveData = JSON.parse(localStorage.getItem("leaveData")) || {};
  const currentUser = JSON.parse(localStorage.getItem("current_user")) || {};

  // useEffect(() => {
  //   const lastSeen = localStorage.getItem("excessLeaveModalSeenDate");
  //   const today = moment().format("YYYY-MM-DD");

  //   if (leaveData.excessLeave > 5 && ((lastSeen !== today) || !lastSeen)) {
  //     setShowModal(true);
  //   }
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const lastSeen = localStorage.getItem("excessLeaveModalSeenDate");
      const today = moment().format("YYYY-MM-DD");
      const leaveData = JSON.parse(localStorage.getItem("leaveData")) || {};
  
      // if (leaveData.excessLeave > 0 && ((lastSeen !== today) || !lastSeen)) {
      //   setShowModal(true);
      //   clearInterval(interval); // stop checking once modal is shown
      // }
    }, 1000);
  
    return () => clearInterval(interval);
  }, []);  

  const handleCloseModal = () => {
    // Save today as the date user has read it
    localStorage.setItem(
      "excessLeaveModalSeenDate",
      moment().format("YYYY-MM-DD")
    );
    setShowModal(false);
  };


  const handleBtnApplyLeave = () => {
    navigate("/LeaveApplicationForm");
  };
  const handleBtnApproveLeave = () => {
    navigate("/LeaveApprovalList");
  };
  const handleBtnMedicalClaim = () => {
    navigate("/MedicalClaimList");
  };

  return (
    <>
      <Container fluid className="py-5" style={{ marginTop: 'var(--navbar-height, 0px)' }}>
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{currentUser.fullname}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="text-start">
              <h3>
                Balance as at{" "}
                <span className="text-primary">
                  {moment().format("MMM D, YYYY")}
                </span>
              </h3>

              <div className="my-4" />

              <p className="fw-bold" style={{ fontSize: "17px" }}>
                Excess Leave To Be Cleared <u>by 31 December 2025</u>:{" "}
                <span className="text-danger" style={{ fontSize: "25px" }}>
                  {leaveData.excessLeave} day(s)
                </span>
              </p>

              <div className="my-4" />

              <p className="fst-italic text-secondary">
                Note: <br />
                Excess leave not cleared by the specified date will be forfeited unless
                approval is obtained to carry forward according to HR Policy.
              </p>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Page Content */}
        <Row className="align-items-center">
          <Col md={6} sm={12} className="text-center mb-5 mb-md-0">
            <h1 className="MainTitle"
            // <h1 className="display-3 fw-normal text-dark"
                // style={{
                //   textShadow: '0px 0px 5px #ffffff, 0px 0px 10px #ffffff'
                // }}
            >
              Leave Application System
            </h1>
          </Col>
          <Col md={6} sm={12} className="px-5">
            <div className="d-grid gap-3">
              <Button
                variant="light"
                size="lg"
                className="py-3 fw-bold border-2 border-dark rounded MainBtn"
                onClick={handleBtnApplyLeave}
              >
                Apply Leave
              </Button>

              {role?.includes('SU-L-APPROVAL') && (
                <Button
                  variant="light"
                  size="lg"
                  className="py-3 fw-bold border-2 border-dark rounded MainBtn"
                  onClick={handleBtnApproveLeave}
                >
                  Approve Leave
                </Button>
              )}

              <Button
                variant="light"
                size="lg"
                className="py-3 fw-bold border-2 border-dark rounded MainBtn"
                onClick={handleBtnMedicalClaim}
              >
                Medical Claim
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
</>
  );
};
export default Homepage;
